define('ordersDetailSupplierEditProductPrintZoneView',[
  'app',
  'module',
  'marionette',
  'settings',
  'backbone',
  'underscore',
  'pdfView',
  'ordersDetailSupplierEditProductPrintZoneImagesView',
  'ordersDetailSupplierEditProductPrintZoneColorsView',
  'template!ordersDetailSupplierEditProductPrintZoneView'
], function (
  App,
  module,
  Marionette,
  Settings,
  Backbone,
  _,
  PdfView,
  ImagesView,
  ColorsView,
  Tpl
) {
  'use strict';

  module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'printzone-view',

    regions: {
      imagesRegion: '.images-region',
      colorsRegion: '.colors-region'
    },

    serializeData: function() {
      var data = {};

      data.printAreaName = '-';
      if(this.model.get('printPositionNameEn'))
        data.printAreaName = this.model.get('printPositionNameEn');

      var printArea = _.findWhere(this.options.product.get('printAreas'), {code: this.model.get('position')});
      var printZone = null;

      if(printArea) {
        printZone = _.findWhere(printArea.printZones, {imppCode: this.model.get('printCode')});
        data.printAreaName = printArea.name;
      }

      data.print = '';
      data.productOwner = '';
      data.size = '';
      data.colors = '';
      data.colorModeType = '';
      if(printZone) {
        if (printZone.printerName !== this.options.order.get('productOwner') && printZone.printerName !== undefined)
          data.productOwner = printZone.printerName;

        if (printArea.name)
          data.printAreaName = printArea.name;

        if(printZone.name)
          data.print = printZone.name;

        data.size = this.model.get('printWidth') + ' x ' + this.model.get('printHeight') + ' mm';

        data.colors = '';

        if (this.model.get('numberOfColors') !== undefined) {
          data.colors = this.model.get('numberOfColors');
          if (this.model.get('nbrColors') > 1)
            data.colors += ' ' + _.i18n('common.colors');
          else
            data.colors += ' ' + _.i18n('common.color');
        }

        data.colorModeType = printZone.colorModeType;
      }
      data.minimumQuantity = this.model.get('minimumQuantity') || 0;
      data.orderQuantity = this.options.order.get('quantity') || 0;
      data.minQtyWarning = data.minimumQuantity > 1 && data.minimumQuantity > data.orderQuantity;

      return data;
    },

    onRender: function () {
      this.imagesView = new ImagesView({
        collection: new Backbone.Collection(this.model.get('files'))
      });
      this.getRegion('imagesRegion').show(this.imagesView);

      this.colorsView = new ColorsView({
        model: this.model
      });
      this.getRegion('colorsRegion').show(this.colorsView);
    }
  });
});
